import equipmentService from '@/services/equipmentService';

const temporaryEquipmentAvs = state => state.temporaryEquipmentAvs;
const avs = state => equipmentService.groupOtherEquipments(state.avs);
const defaultAvEquipments = state => state.defaultAvEquipments;
const vehicleEquipmentList = state => state.vehicleEquipmentList;
const selectedEquipments = state => state.selectedEquipments;
const skipEquipmentSelection = state => state.skipEquipmentSelection;

export default {
  temporaryEquipmentAvs,
  avs,
  defaultAvEquipments,
  vehicleEquipmentList,
  selectedEquipments,
  skipEquipmentSelection
}
